import { Link } from "react-router-dom";

export default function About1() {
	return (
		<div className="tf-widget-about-us">
			{/* 
        ============================ 
        TFD SELECT (images right, beige background)
        ============================
        */}
			<div
				className="themeflat-container tf-about-us section-alt-bg"
				style={{ backgroundColor: "#e7d42f;" }}
			>
				<div className="row flex-row-reverse">
					{/* Images on the right */}
					<div className="col-md-6 image-wraper">
						<h1
							className="title-section wow fadeInUp animated"
							style={{
								color: "#000",
								fontSize: "2.8rem", // Larger text
								fontWeight: 900, // Bolder
								letterSpacing: "0.05em", // Slight spacing
								textShadow: "0 2px 4px rgba(0.1, 0, 0.2, 0.7)", // Subtle shadow
							}}
						>
							TFD SELECT
						</h1>
						<div className="media">
							<img
								className="mask-media wow fadeInLeft animated"
								src="images/realmadridone.jpeg"
								alt="TFD Select"
							/>
						</div>
					</div>

					{/* Text on the left */}
					<div className="col-md-6">
						<div className="about-box">
							<div className="title-box title-small-v2">
								<span
									className="sub-title wow fadeInUp animated"
									style={{ color: "#000" }}
								>
									Building brilliantly driven habits into Perth’s local best
									footballers. Be brave enough and bold enough to go and play
									the best in the country, and the best on the planet.
								</span>
							</div>
							<p
								className="post wow fadeInUp animated"
								style={{ color: "#000" }}
							>
								Join us in shaping the future of the most competitive
								footballers in Perth—one player at a time. Enroll today and let
								the journey begin! Give your child the chance to learn, grow,
								and shine. We’re more than just a football academy—we are
								authentically pursuing globally comparable excellence on behalf
								of WA’s talented young footballers from u8 – u23.
							</p>

							<div className="line" />

							<div className="about-button-group">
								<Link to="https://form.jotform.com/250228383921860">
									<button className="flat-button wow fadeInUp animated">
										Express Interest{" "}
									</button>
								</Link>
							</div>

							{/* Quote */}
							<blockquote style={{ color: "#000", marginTop: "1.5rem" }}>
								“Training with Ben O’Neill at TFD built me from the ground up”.
								<footer style={{ marginTop: "-1.5rem" }}>
									— Chris Donnell, Fulham FC U23 Captain
								</footer>
							</blockquote>

							{/* Polaroids BELOW the text/quote */}
							<div className="polaroid-container polaroid-below">
								<div className="polaroid bw">
									<img
										src="/images/WhatsApp Image 2025-02-07 at 11.35.37 AM.jpeg"
										alt="Chris Donnell B&W"
									/>
								</div>
								<div className="polaroid color">
									<img src="/images/image.png" alt="Christian Donnell Color" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* end TFD Select section */}

			{/* 
        ============================ 
        TFD INTERNATIONAL (images left, white background)
        ============================
      */}
			<div
				className="themeflat-container tf-about-us section-default-bg"
				style={{ backgroundColor: "#FFF" }}
			>
				<div className="row">
					{/* Images on the left */}
					<div className="col-md-6 image-wraper">
						<h1
							className="title-section wow fadeInUp animated"
							style={{
								color: "#000",
								fontSize: "2.8rem", // Larger text
								fontWeight: 900, // Bolder
								letterSpacing: "0.05em", // Slight spacing
								textShadow: "0 2px 4px rgba(0.1, 0, 0.2, 0.7)", // Subtle shadow
							}}
						>
							TFD INTERNATIONALS
						</h1>
						<div className="media">
							<img
								className="mask-media wow fadeInLeft animated"
								src="images/4581a34e-fc30-40d8-ab7f-ce6c798a6565.jpeg"
								alt="TFD Internationals"
							/>
						</div>
					</div>

					{/* Text on the right */}
					<div className="col-md-6">
						<div className="about-box">
							<div className="title-box title-small-v2">
								<span
									className="sub-title wow fadeInUp animated"
									style={{ color: "#000" }}
								>
									Taking WA’s footballers to the world’s best!
								</span>
							</div>
							<p
								className="post wow fadeInUp animated"
								style={{ color: "#000" }}
							>
								TFD International tours connect players to a broader football
								culture using the philosophies from the greatest clubs in the
								game. Whether you aim to play overseas, train with international
								coaches, or simply broaden your skill set, TFD International
								tours provide the perfect environment. With connections at
								Manchester City, Liverpool, Real Madrid and more, we deliver the
								most competitive opportunities for our WA footballers and
								provide unforgettable football experiences.
							</p>

							<div className="line" />

							<div className="about-button-group">
								<Link to="/contact">
									<button className="flat-button wow fadeInUp animated">
										Express Interest
									</button>
								</Link>
							</div>

							{/* Quote */}
							<blockquote style={{ color: "#000", marginTop: "1.5rem" }}>
								“Travelling with TFD gave me a real insight for what it takes to
								become a pro footballer. I came back from that trip with a clear
								understanding of how to reach my goals, and the experience still
								drives me to the highest standards today.”
								<footer style={{ marginTop: "-1.5rem" }}>
									— Christian Pullella, Perth Glory & Australia Youth
								</footer>
							</blockquote>

							{/* Polaroids BELOW the text/quote */}
							<div className="polaroid-container polaroid-below">
								<div className="polaroid bw">
									<img
										src="/images/IMG_2904 (1).JPG"
										alt="Christian Pullella B&W"
									/>
								</div>
								<div className="polaroid color">
									<img
										src="/images/image copy.png"
										alt="Christian Pullella Color"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* end TFD International section */}

			{/* 
        ============================ 
        TFD ACCELERATE (images right, beige background)
        ============================
      */}
			<div
				className="themeflat-container tf-about-us section-alt-bg"
				style={{ backgroundColor: "#e7d42f;" }}
			>
				<div className="row flex-row-reverse">
					{/* Images on the right */}
					<div className="col-md-6 image-wraper">
						<h1
							className="title-section wow fadeInUp animated"
							style={{
								color: "#000",
								fontSize: "2.8rem", // Larger text
								fontWeight: 900, // Bolder
								letterSpacing: "0.05em", // Slight spacing
								textShadow: "0 2px 4px rgba(0.1, 0, 0.2, 0.7)", // Subtle shadow
							}}
						>
							TFD ACCELERATE
						</h1>
						<div className="media">
							<img
								className="mask-media wow fadeInLeft animated"
								src="images/image copy 2.png"
								alt="TFD Accelerate"
							/>
						</div>
					</div>

					{/* Text on the left */}
					<div className="col-md-6">
						<div className="about-box">
							<div className="title-box title-small-v2">
								<span
									className="sub-title wow fadeInUp animated"
									style={{ color: "#000" }}
								>
									If you love this game, we will make you love it more.
								</span>
							</div>
							<p
								className="post wow fadeInUp animated"
								style={{ color: "#000" }}
							>
								Giving players the tools, support, and opportunities to become
								confident individuals on and off the pitch. Our Accelerate
								program focuses on the holistic player development; building
								resilience, and preparing footballers to become the best version
								of themselves. Boys and girls aged 3 - 16yo can connect to TFD
								pathways on a national and international level in this
								accelerate program that offers an abundance of positivity, a
								wealth of knowledge and experience, and a ridiculous amount of
								love for the game.
							</p>

							<div className="line" />

							<div className="about-button-group">
								<Link to="https://form.jotform.com/Admin_TFD/tfd-accelerate-term-3">
									<button
										className="flat-button wow fadeInUp animated"
										style={{
											fontSize: "2.2rem", // Larger text
											fontWeight: 550, // Bolder
											letterSpacing: "0.05em", // Slight spacing
											marginLeft: "40px",
											height: "60px",
										}}
									>
										Register Here{" "}
									</button>
								</Link>
							</div>

							{/* Quote */}
							<blockquote style={{ color: "#000", marginTop: "1.5rem" }}>
								“The level of detail the coaches always showed me at TFD was
								excellent. Always looking to get the best out of me in every
								training session I was able to progress so quickly and the
								sessions were really enjoyable.”
								<footer style={{ marginTop: "-1.5rem" }}>
									— Grace Johnston, Perth Glory FC Women & Australia Women
								</footer>
							</blockquote>

							{/* Polaroids BELOW the text/quote */}
							<div className="polaroid-container polaroid-below">
								<div className="polaroid bw">
									<img
										src="/images/GRACEJOHNSON.jpeg"
										alt="Grace Johnston B&W"
									/>
								</div>
								<div className="polaroid color">
									<img src="/images/grace.jpeg" alt="Grace Johnston Color" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* end TFD Accelerate section */}

			{/* 
        ============================ 
        TFD DOMESTIC (images left, white background)
        ============================
        */}
			<div
				className="themeflat-container tf-about-us section-default-bg"
				style={{ backgroundColor: "#FFF" }}
			>
				<div className="row">
					{/* Images on the left */}
					<div className="col-md-6 image-wraper">
						<h1
							className="title-section wow fadeInUp animated"
							style={{
								color: "#000",
								fontSize: "2.8rem", // Larger text
								fontWeight: 900, // Bolder
								letterSpacing: "0.05em", // Slight spacing
								textShadow: "0 2px 4px rgba(0.1, 0, 0.2, 0.7)", // Subtle shadow
							}}
						>
							TFD DOMESTIC
						</h1>
						<div className="media">
							<img
								className="mask-media wow fadeInLeft animated"
								src="images/domestic.jpeg"
								alt="TFD Domestic"
							/>
						</div>
					</div>

					{/* Text on the right */}
					<div className="col-md-6">
						<div className="about-box">
							<div className="title-box title-small-v2">
								<span
									className="sub-title wow fadeInUp animated"
									style={{ color: "#000" }}
								>
									Challenging Perth’s best with the best in the nation and
									providing footballers with a fantastic football experience
									they get to share with their friends and family.
								</span>
							</div>
							<p
								className="post wow fadeInUp animated"
								style={{ color: "#000" }}
							>
								Travel to cities across Australia to compete against some of the
								country's best. This experience can create squad memories for a
								lifetime but also develop the mentality required to compete both
								on and off the pitch. With fantastic football experiences on
								offer, it really enhances the volume of expectation for what is
								required to demonstrate composure, leadership, problem-solving
								skills, and so much more whilst young footballers embrace
								themselves in this highly intense national standard.
							</p>

							<div className="line" />

							<div className="about-button-group">
								<Link to="https://form.jotform.com/241378533797470">
									<button className="flat-button wow fadeInUp animated">
										Express Interest
									</button>
								</Link>
							</div>

							{/* Quote */}
							<blockquote style={{ color: "#000", marginTop: "1.5rem" }}>
								“You could see this kid had something special about him; calm,
								highly driven with a real hunger to compete. There was a moment
								that summed it up perfectly as TFD were a goal behind against
								our strongest side, one that had beaten Liverpool on their most
								recent tour… Denis took a heavy knock from one of our lads and
								couldn’t hide his emotions and frustrations but that didn’t stop
								him as he showed his character and his resilience to step up
								with an unbelievable equaliser! Great desire from the young
								man.”
								<footer style={{ marginTop: "-1.5rem" }}>— Nick Rizzo</footer>
							</blockquote>
							<p style={{ marginTop: "0.5rem", color: "#000" }}>
								Denis Murphy, 2.5yrs with TFD now signed with Liverpool FC U10
							</p>

							{/* Polaroids BELOW the text/quote */}
							<div className="polaroid-container polaroid-below">
								<div className="polaroid bw">
									<img src="/images/denis.jpeg" alt="Denis Murphy B&W" />
								</div>
								<div className="polaroid color">
									<img src="/images/denis3.jpeg" alt="Denis Murphy Color" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* end TFD Domestic section */}

			{/* 
        ============================ 
        PRIVATE SESSIONS (images right, beige background)
        ============================
      */}
			{/*
  ============================
  PRIVATE SESSIONS (images right, beige background)
  ============================
*/}
			<div
				className="themeflat-container tf-about-us section-alt-bg"
				style={{ backgroundColor: "#e7d42f;" }}
			>
				<div className="row flex-row-reverse">
					{/* Images on the right */}
					<div className="col-md-6 image-wraper">
						<h1
							className="title-section wow fadeInUp animated"
							style={{
								color: "#000",
								fontSize: "2.8rem", // Larger text
								fontWeight: 900, // Bolder
								letterSpacing: "0.05em", // Slight spacing
								textShadow: "0 2px 4px rgba(0.1, 0, 0.2, 0.7)", // Subtle shadow
							}}
						>
							PRIVATE SESSIONS
						</h1>
						<div className="media">
							<video
								className="mask-media wow fadeInLeft animated"
								controls
								playsInline
								webkit-playsinline="true"
								width="100%"
							>
								<source
									src="images/WhatsApp Video 2025-02-10 at 10.37.47 AM.mp4"
									type="video/mp4"
								/>
								Your browser does not support the video tag.
							</video>
						</div>
					</div>

					{/* Text on the left */}
					<div className="col-md-6">
						<div className="about-box">
							<div className="title-box title-small-v2">
								<span
									className="sub-title wow fadeInUp animated"
									style={{ color: "#000" }}
								>
									Personalised Development Plan (PDP)
								</span>
							</div>
							<p
								className="post wow fadeInUp animated"
								style={{ color: "#000" }}
							>
								Looking to target specific areas of your game? Our private
								sessions—as recommended by the top professionals—are adaptable
								to any skill level. Our methodologies challenge your technical,
								tactical, physiological, and psychological aspects, ensuring you
								become a more complete player.
							</p>
							<p style={{ color: "#000", fontStyle: "italic" }}>
								1v1 : 2v1 : 3v1 : 4v1
							</p>

							<div className="line" />

							<div className="about-button-group">
								<Link to="https://form.jotform.com/242632295471862?fbclid=IwY2xjawIWpKJleHRuA2FlbQIxMAABHVCagXoPRycpxsox9uRgxlLhrIzMA90VeyXNeq954E82c9I2kncBOD35Yw_aem_0FB722UjMRodK5iYu-1UuA">
									<button className="flat-button wow fadeInUp animated">
										Book Private Session
									</button>
								</Link>
							</div>

							{/*
          ===========================================
          CLAIM YOUR FREE TRIAL BANNER
          ===========================================
        */}
							<div
								className="free-trial-banner wow fadeInUp animated"
								style={{
									backgroundColor: "#fff",
									padding: "20px",
									marginTop: "1.5rem",
									borderRadius: "4px",
									boxShadow: "0 0 8px rgba(0,0,0,0.1)",
								}}
							>
								<h3 style={{ color: "#000", marginBottom: "0.5rem" }}>
									Claim Your Free Trial
								</h3>
								<p style={{ color: "#000", marginBottom: "1rem" }}>
									Experience TFD’s methodology firsthand with a complimentary
									mini-session. Ready to discover how private coaching can
									elevate your game?
								</p>
								<Link to="https://form.jotform.com/242558615184866">
									<button
										className="flat-button"
										style={{ backgroundColor: "#000", color: "#fff" }}
									>
										Claim Free Trial
									</button>
								</Link>
							</div>
							{/* End Free Trial Banner */}
						</div>
					</div>
				</div>
			</div>
			{/* end Private Sessions section */}

			{/* end Private Sessions section */}
		</div>
	);
}
